import { forwardRef, useRef, useEffect } from 'react';
import { renderDownloadThrobber } from '@utils/common';
import { jsx } from 'react/jsx-runtime';
import { assertRefObject } from '../functions/assert-ref-object.js';

const Throbber = /*#__PURE__*/forwardRef(function Throbber(props, ref) {
  const internalRef = useRef(null);
  const canvasRef = ref ?? internalRef;
  assertRefObject(canvasRef);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    renderDownloadThrobber(canvas, props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/jsx("canvas", {
    className: props.className,
    ref: canvasRef
  });
});

export { Throbber };
//# sourceMappingURL=throbber.js.map
